// const contractList = () => import('./contractList');
const orderList = () => import('./orderList');
// const payInvite = () => import('./payInvite');
const jmOrderList2022 = () => import('@/pages/student/payment/jmOrderList2022');
const qcOrderList2022 = () => import('@/pages/student/payment/qcOrderList2022');
const orderRoute2022 = () => import('./orderRoute2022');
const payList2022 = () => import('./payList2022');
const commissionList = () => import('./commissionList');
const commissionForm = () => import('./commissionForm');

const paymentRouter = [
  {
    path: '/payment/index', name: 'paymentindex', component: orderList, meta: { c: 'payment', a: 'index' }
  },
  // {
  //   path: '/payment/contract', name: 'contract', component: contractList, meta: { c: 'payment', a: 'contract' }
  // },
  // {
  //   path: '/payment/create/:crmid/:type', name: 'paymentcreate', component: payInvite, meta: { c: 'payment', a: 'create' }
  // },
  // {
  //   path: '/payment/edit/:crmid/:orderNum', name: 'paymentedit', component: payInvite, meta: { c: 'payment', a: 'edit' }
  // },
  {
    path: '/payment/jmOrderList', name: 'jmOrderList2022', component: jmOrderList2022, meta: { c: 'payment', a: 'jmOrderList' }
  },
  {
    path: '/payment/qcOrderList', name: 'qcOrderList2022', component: qcOrderList2022, meta: { c: 'payment', a: 'qcOrderList' }
  },
  {
    path: '/payment/orderRoute', name: 'orderRoute2022', component: orderRoute2022, meta: { c: 'payment', a: 'orderRoute' }
  },
  {
    path: '/payment/jmpayList', name: 'jmPayList2022', component: payList2022, meta: { c: 'payment', a: 'jmpayList' }
  },
  {
    path: '/payment/qcpayList', name: 'qcPayList2022', component: payList2022, meta: { c: 'payment', a: 'qcpayList' }
  },
  {
    path: '/payment/commissionList', name: 'commissionList', component: commissionList, meta: { c: 'payment', a: 'commissionList' }
  },
  {
    path: '/payment/commission/add', name: 'commissionAdd', component: commissionForm, meta: { c: 'payment', a: 'commissionAdd' }
  },
  {
    path: '/payment/commission/:id', name: 'commissionEdit', component: commissionForm, meta: { c: 'payment', a: 'commissionEdit' }
  },
];

export default paymentRouter;
